import { ApiLocalStorage } from './ApiLocalStorage';

export function getTermsTextConfig() {
  const theme = ApiLocalStorage.get('theme') || {};
  return theme?.['signupConfig-fml']?.['termsText-fml'] || {};
} 